export const asteroids = {
  "2062 Aten (1976 AA)": {
    "name": "2062 Aten (1976 AA)",
    "epoch_mjd": 60600.0,
    "a": 0.967,
    "e": 0.1829,
    "i": 18.93,
    "om": 108.53,
    "w": 148.06,
    "ma": 338.03,
    "diameter": 1.1,
    "pha": "N",
    "class": "ATE",
    "per": "347"
  },
  "2100 Ra-Shalom (1978 RA)": {
    "name": "2100 Ra-Shalom (1978 RA)",
    "epoch_mjd": 60600.0,
    "a": 0.832,
    "e": 0.4365,
    "i": 15.75,
    "om": 170.78,
    "w": 356.08,
    "ma": 89.62,
    "diameter": 2.3,
    "pha": "N",
    "class": "ATE",
    "per": "277"
  },
  "2340 Hathor (1976 UA)": {
    "name": "2340 Hathor (1976 UA)",
    "epoch_mjd": 60600.0,
    "a": 0.8438,
    "e": 0.45,
    "i": 5.86,
    "om": 211.29,
    "w": 40.1,
    "ma": 53.4,
    "diameter": 0.3,
    "pha": "Y",
    "class": "ATE",
    "per": "283"
  },
  "3362 Khufu (1984 QA)": {
    "name": "3362 Khufu (1984 QA)",
    "epoch_mjd": 60600.0,
    "a": 0.9895,
    "e": 0.4685,
    "i": 9.92,
    "om": 152.4,
    "w": 55.09,
    "ma": 359.85,
    "diameter": 0.7,
    "pha": "Y",
    "class": "ATE",
    "per": "360"
  },
  "3554 Amun (1986 EB)": {
    "name": "3554 Amun (1986 EB)",
    "epoch_mjd": 60600.0,
    "a": 0.974,
    "e": 0.2806,
    "i": 23.36,
    "om": 358.6,
    "w": 359.42,
    "ma": 226.57,
    "diameter": 3.341,
    "pha": "N",
    "class": "ATE",
    "per": "351"
  },
  "3753 Cruithne (1986 TO)": {
    "name": "3753 Cruithne (1986 TO)",
    "epoch_mjd": 60600.0,
    "a": 0.9978,
    "e": 0.5148,
    "i": 19.8,
    "om": 126.19,
    "w": 43.88,
    "ma": 308.8,
    "diameter": 2.071,
    "pha": "N",
    "class": "ATE",
    "per": "364"
  },
  "5381 Sekhmet (1991 JY)": {
    "name": "5381 Sekhmet (1991 JY)",
    "epoch_mjd": 60600.0,
    "a": 0.9475,
    "e": 0.2964,
    "i": 48.97,
    "om": 58.53,
    "w": 37.42,
    "ma": 199.13,
    "diameter": 0.935,
    "pha": "N",
    "class": "ATE",
    "per": "337"
  },
  "5604 (1992 FE)": {
    "name": "5604 (1992 FE)",
    "epoch_mjd": 60600.0,
    "a": 0.9286,
    "e": 0.4061,
    "i": 4.71,
    "om": 311.89,
    "w": 82.68,
    "ma": 269.92,
    "diameter": 0.55,
    "pha": "Y",
    "class": "ATE",
    "per": "327"
  },
  "33342 (1998 WT24)": {
    "name": "33342 (1998 WT24)",
    "epoch_mjd": 60600.0,
    "a": 0.7187,
    "e": 0.4177,
    "i": 7.37,
    "om": 81.66,
    "w": 167.52,
    "ma": 27.5,
    "diameter": 0.432,
    "pha": "Y",
    "class": "ATE",
    "per": "223"
  },
  "65679 (1989 UQ)": {
    "name": "65679 (1989 UQ)",
    "epoch_mjd": 60600.0,
    "a": 0.9148,
    "e": 0.2647,
    "i": 1.3,
    "om": 178.08,
    "w": 15.01,
    "ma": 195.92,
    "diameter": 0.918,
    "pha": "Y",
    "class": "ATE",
    "per": "320"
  },
  "66146 (1998 TU3)": {
    "name": "66146 (1998 TU3)",
    "epoch_mjd": 60600.0,
    "a": 0.7875,
    "e": 0.4838,
    "i": 5.41,
    "om": 101.97,
    "w": 84.91,
    "ma": 230.7,
    "diameter": 2.864,
    "pha": "N",
    "class": "ATE",
    "per": "255"
  },
  "66391 Moshup (1999 KW4)": {
    "name": "66391 Moshup (1999 KW4)",
    "epoch_mjd": 60600.0,
    "a": 0.6424,
    "e": 0.6884,
    "i": 38.88,
    "om": 244.9,
    "w": 192.65,
    "ma": 296.9,
    "diameter": 1.317,
    "pha": "Y",
    "class": "ATE",
    "per": "188"
  },
  "66400 (1999 LT7)": {
    "name": "66400 (1999 LT7)",
    "epoch_mjd": 60600.0,
    "a": 0.8554,
    "e": 0.5726,
    "i": 9.06,
    "om": 79.8,
    "w": 341.41,
    "ma": 247.27,
    "diameter": 0.411,
    "pha": "N",
    "class": "ATE",
    "per": "289"
  },
  "85953 (1999 FK21)": {
    "name": "85953 (1999 FK21)",
    "epoch_mjd": 60600.0,
    "a": 0.7388,
    "e": 0.703,
    "i": 12.6,
    "om": 180.45,
    "w": 172.42,
    "ma": 358.2,
    "diameter": 0.59,
    "pha": "N",
    "class": "ATE",
    "per": "232"
  },
  "85989 (1999 JD6)": {
    "name": "85989 (1999 JD6)",
    "epoch_mjd": 60600.0,
    "a": 0.8831,
    "e": 0.6329,
    "i": 17.07,
    "om": 130.15,
    "w": 309.25,
    "ma": 338.43,
    "diameter": 1.462,
    "pha": "Y",
    "class": "ATE",
    "per": "303"
  },
  "86667 (2000 FO10)": {
    "name": "86667 (2000 FO10)",
    "epoch_mjd": 60600.0,
    "a": 0.8594,
    "e": 0.5946,
    "i": 14.29,
    "om": 208.3,
    "w": 172.49,
    "ma": 94.23,
    "diameter": 0.745,
    "pha": "N",
    "class": "ATE",
    "per": "291"
  },
  "87309 (2000 QP)": {
    "name": "87309 (2000 QP)",
    "epoch_mjd": 60600.0,
    "a": 0.8475,
    "e": 0.4631,
    "i": 34.74,
    "om": 294.27,
    "w": 188.17,
    "ma": 229.25,
    "diameter": 0.568,
    "pha": "N",
    "class": "ATE",
    "per": "285"
  },
  "88213 (2001 AF2)": {
    "name": "88213 (2001 AF2)",
    "epoch_mjd": 60600.0,
    "a": 0.954,
    "e": 0.5952,
    "i": 17.81,
    "om": 114.25,
    "w": 194.99,
    "ma": 314.29,
    "diameter": 0.912,
    "pha": "N",
    "class": "ATE",
    "per": "340"
  },
  "96590 (1998 XB)": {
    "name": "96590 (1998 XB)",
    "epoch_mjd": 60600.0,
    "a": 0.9079,
    "e": 0.3512,
    "i": 13.6,
    "om": 75.68,
    "w": 202.7,
    "ma": 157.89,
    "diameter": 0.882,
    "pha": "N",
    "class": "ATE",
    "per": "316"
  },
  "99907 (1989 VA)": {
    "name": "99907 (1989 VA)",
    "epoch_mjd": 60600.0,
    "a": 0.7284,
    "e": 0.5948,
    "i": 28.8,
    "om": 225.58,
    "w": 2.87,
    "ma": 241.61,
    "diameter": 1.4,
    "pha": "N",
    "class": "ATE",
    "per": "227"
  },
  "105140 (2000 NL10)": {
    "name": "105140 (2000 NL10)",
    "epoch_mjd": 60600.0,
    "a": 0.9143,
    "e": 0.8169,
    "i": 32.54,
    "om": 237.29,
    "w": 281.67,
    "ma": 35.84,
    "diameter": 1.946,
    "pha": "N",
    "class": "ATE",
    "per": "319"
  },
  "137805 (1999 YK5)": {
    "name": "137805 (1999 YK5)",
    "epoch_mjd": 60600.0,
    "a": 0.8294,
    "e": 0.5583,
    "i": 16.75,
    "om": 349.53,
    "w": 292.86,
    "ma": 90.64,
    "diameter": 2.243,
    "pha": "N",
    "class": "ATE",
    "per": "276"
  },
  "137924 (2000 BD19)": {
    "name": "137924 (2000 BD19)",
    "epoch_mjd": 60600.0,
    "a": 0.8764,
    "e": 0.8949,
    "i": 25.74,
    "om": 333.69,
    "w": 324.35,
    "ma": 212.72,
    "diameter": 0.97,
    "pha": "N",
    "class": "ATE",
    "per": "300"
  },
  "138127 (2000 EE14)": {
    "name": "138127 (2000 EE14)",
    "epoch_mjd": 60600.0,
    "a": 0.6618,
    "e": 0.5331,
    "i": 26.46,
    "om": 155.75,
    "w": 197.86,
    "ma": 76.31,
    "diameter": 0.754,
    "pha": "Y",
    "class": "ATE",
    "per": "197"
  },
  "141432 (2002 CQ11)": {
    "name": "141432 (2002 CQ11)",
    "epoch_mjd": 60600.0,
    "a": 0.9762,
    "e": 0.4275,
    "i": 2.47,
    "om": 81.34,
    "w": 272.65,
    "ma": 241.7,
    "diameter": 0.239,
    "pha": "Y",
    "class": "ATE",
    "per": "352"
  },
  "141484 (2002 DB4)": {
    "name": "141484 (2002 DB4)",
    "epoch_mjd": 60600.0,
    "a": 0.8579,
    "e": 0.3695,
    "i": 16.6,
    "om": 234.23,
    "w": 94.16,
    "ma": 279.38,
    "diameter": 1.034,
    "pha": "N",
    "class": "ATE",
    "per": "290"
  },
  "152563 (1992 BF)": {
    "name": "152563 (1992 BF)",
    "epoch_mjd": 60600.0,
    "a": 0.9079,
    "e": 0.2716,
    "i": 7.25,
    "om": 315.19,
    "w": 336.55,
    "ma": 146.53,
    "diameter": 0.272,
    "pha": "N",
    "class": "ATE",
    "per": "316"
  },
  "152742 (1998 XE12)": {
    "name": "152742 (1998 XE12)",
    "epoch_mjd": 60600.0,
    "a": 0.8781,
    "e": 0.7392,
    "i": 13.43,
    "om": 280.02,
    "w": 353.16,
    "ma": 257.41,
    "diameter": 0.413,
    "pha": "N",
    "class": "ATE",
    "per": "301"
  },
  "152931 (2000 EA107)": {
    "name": "152931 (2000 EA107)",
    "epoch_mjd": 60600.0,
    "a": 0.9297,
    "e": 0.4557,
    "i": 28.58,
    "om": 52.88,
    "w": 278.02,
    "ma": 337.31,
    "diameter": 1.646,
    "pha": "N",
    "class": "ATE",
    "per": "327"
  },
  "153201 (2000 WO107)": {
    "name": "153201 (2000 WO107)",
    "epoch_mjd": 60600.0,
    "a": 0.9111,
    "e": 0.7808,
    "i": 7.77,
    "om": 69.2,
    "w": 213.75,
    "ma": 219.51,
    "diameter": 0.51,
    "pha": "Y",
    "class": "ATE",
    "per": "318"
  },
  "162080 (1998 DG16)": {
    "name": "162080 (1998 DG16)",
    "epoch_mjd": 60600.0,
    "a": 0.8967,
    "e": 0.3582,
    "i": 16.21,
    "om": 344.33,
    "w": 356.88,
    "ma": 323.78,
    "diameter": 0.777,
    "pha": "N",
    "class": "ATE",
    "per": "310"
  },
  "162142 (1998 VR)": {
    "name": "162142 (1998 VR)",
    "epoch_mjd": 60600.0,
    "a": 0.8753,
    "e": 0.3179,
    "i": 21.81,
    "om": 46.36,
    "w": 170.75,
    "ma": 75.02,
    "diameter": 0.462,
    "pha": "N",
    "class": "ATE",
    "per": "299"
  },
  "162385 (2000 BM19)": {
    "name": "162385 (2000 BM19)",
    "epoch_mjd": 60600.0,
    "a": 0.7407,
    "e": 0.3586,
    "i": 6.88,
    "om": 70.21,
    "w": 247.71,
    "ma": 47.29,
    "diameter": 0.812,
    "pha": "N",
    "class": "ATE",
    "per": "233"
  },
  "162483 (2000 PJ5)": {
    "name": "162483 (2000 PJ5)",
    "epoch_mjd": 60600.0,
    "a": 0.8727,
    "e": 0.3737,
    "i": 51.18,
    "om": 124.41,
    "w": 7.65,
    "ma": 22.18,
    "diameter": 0.906,
    "pha": "N",
    "class": "ATE",
    "per": "298"
  },
  "163243 (2002 FB3)": {
    "name": "163243 (2002 FB3)",
    "epoch_mjd": 60600.0,
    "a": 0.7616,
    "e": 0.6016,
    "i": 20.28,
    "om": 203.56,
    "w": 148.34,
    "ma": 109.4,
    "diameter": 1.682,
    "pha": "Y",
    "class": "ATE",
    "per": "243"
  },
  "163348 (2002 NN4)": {
    "name": "163348 (2002 NN4)",
    "epoch_mjd": 60600.0,
    "a": 0.8758,
    "e": 0.4345,
    "i": 5.42,
    "om": 259.43,
    "w": 222.21,
    "ma": 207.78,
    "diameter": 0.735,
    "pha": "Y",
    "class": "ATE",
    "per": "299"
  },
  "163899 (2003 SD220)": {
    "name": "163899 (2003 SD220)",
    "epoch_mjd": 60600.0,
    "a": 0.8276,
    "e": 0.21,
    "i": 8.54,
    "om": 273.71,
    "w": 326.99,
    "ma": 128.47,
    "diameter": 0.791,
    "pha": "Y",
    "class": "ATE",
    "per": "275"
  },
  "215442 (2002 MQ3)": {
    "name": "215442 (2002 MQ3)",
    "epoch_mjd": 60600.0,
    "a": 0.9137,
    "e": 0.2743,
    "i": 36.29,
    "om": 109.06,
    "w": 346.89,
    "ma": 352.21,
    "diameter": 1.075,
    "pha": "N",
    "class": "ATE",
    "per": "319"
  },
  "234145 (2000 EW70)": {
    "name": "234145 (2000 EW70)",
    "epoch_mjd": 60600.0,
    "a": 0.9376,
    "e": 0.3213,
    "i": 5.43,
    "om": 178.03,
    "w": 125.77,
    "ma": 294.52,
    "diameter": 0.344,
    "pha": "Y",
    "class": "ATE",
    "per": "332"
  },
  "234341 (2001 FZ57)": {
    "name": "234341 (2001 FZ57)",
    "epoch_mjd": 60600.0,
    "a": 0.9442,
    "e": 0.6042,
    "i": 20.67,
    "om": 22.09,
    "w": 339.98,
    "ma": 96.2,
    "diameter": 0.344,
    "pha": "N",
    "class": "ATE",
    "per": "335"
  },
  "242191 (2003 NZ6)": {
    "name": "242191 (2003 NZ6)",
    "epoch_mjd": 60600.0,
    "a": 0.7934,
    "e": 0.4924,
    "i": 18.25,
    "om": 124.58,
    "w": 311.62,
    "ma": 294.05,
    "diameter": 0.37,
    "pha": "N",
    "class": "ATE",
    "per": "258"
  },
  "247517 (2002 QY6)": {
    "name": "247517 (2002 QY6)",
    "epoch_mjd": 60600.0,
    "a": 0.8171,
    "e": 0.699,
    "i": 12.75,
    "om": 164.18,
    "w": 355.4,
    "ma": 167.83,
    "diameter": 0.269,
    "pha": "N",
    "class": "ATE",
    "per": "270"
  },
  "250680 (2005 QC5)": {
    "name": "250680 (2005 QC5)",
    "epoch_mjd": 60600.0,
    "a": 0.893,
    "e": 0.3645,
    "i": 9.45,
    "om": 48.05,
    "w": 108.72,
    "ma": 64.8,
    "diameter": 0.398,
    "pha": "Y",
    "class": "ATE",
    "per": "308"
  },
  "252399 (2001 TX44)": {
    "name": "252399 (2001 TX44)",
    "epoch_mjd": 60600.0,
    "a": 0.8748,
    "e": 0.5459,
    "i": 15.21,
    "om": 57.76,
    "w": 136.04,
    "ma": 262.54,
    "diameter": 0.291,
    "pha": "Y",
    "class": "ATE",
    "per": "299"
  },
  "260277 (2004 TR12)": {
    "name": "260277 (2004 TR12)",
    "epoch_mjd": 60600.0,
    "a": 0.8952,
    "e": 0.2097,
    "i": 19.36,
    "om": 155.35,
    "w": 77.78,
    "ma": 352.01,
    "diameter": 0.47,
    "pha": "N",
    "class": "ATE",
    "per": "309"
  },
  "262623 (2006 WY2)": {
    "name": "262623 (2006 WY2)",
    "epoch_mjd": 60600.0,
    "a": 0.9833,
    "e": 0.3329,
    "i": 27.55,
    "om": 99.83,
    "w": 159.97,
    "ma": 243.79,
    "diameter": 0.761,
    "pha": "N",
    "class": "ATE",
    "per": "356"
  },
  "264357 (2000 AZ93)": {
    "name": "264357 (2000 AZ93)",
    "epoch_mjd": 60600.0,
    "a": 0.7469,
    "e": 0.36,
    "i": 8.59,
    "om": 277.3,
    "w": 8.17,
    "ma": 311.13,
    "diameter": 0.113,
    "pha": "Y",
    "class": "ATE",
    "per": "236"
  },
  "297418 (2000 SP43)": {
    "name": "297418 (2000 SP43)",
    "epoch_mjd": 60600.0,
    "a": 0.8115,
    "e": 0.4669,
    "i": 10.34,
    "om": 350.53,
    "w": 224.46,
    "ma": 70.52,
    "diameter": 0.407,
    "pha": "Y",
    "class": "ATE",
    "per": "267"
  },
  "307918 (2004 EU9)": {
    "name": "307918 (2004 EU9)",
    "epoch_mjd": 60600.0,
    "a": 0.8804,
    "e": 0.5053,
    "i": 28.58,
    "om": 161.08,
    "w": 202.43,
    "ma": 98.26,
    "diameter": 0.374,
    "pha": "N",
    "class": "ATE",
    "per": "302"
  },
  "311554 (2006 BQ147)": {
    "name": "311554 (2006 BQ147)",
    "epoch_mjd": 60600.0,
    "a": 0.8199,
    "e": 0.4223,
    "i": 24.38,
    "om": 146.77,
    "w": 153.21,
    "ma": 224.39,
    "diameter": 0.382,
    "pha": "N",
    "class": "ATE",
    "per": "271"
  },
  "312070 (2007 TA19)": {
    "name": "312070 (2007 TA19)",
    "epoch_mjd": 60600.0,
    "a": 0.9539,
    "e": 0.5096,
    "i": 22.63,
    "om": 181.18,
    "w": 58.06,
    "ma": 176.51,
    "diameter": 0.595,
    "pha": "Y",
    "class": "ATE",
    "per": "340"
  },
  "315098 (2007 EX)": {
    "name": "315098 (2007 EX)",
    "epoch_mjd": 60600.0,
    "a": 0.8716,
    "e": 0.4174,
    "i": 18.7,
    "om": 297.42,
    "w": 78.89,
    "ma": 344.27,
    "diameter": 0.993,
    "pha": "N",
    "class": "ATE",
    "per": "297"
  },
  "325102 (2008 EY5)": {
    "name": "325102 (2008 EY5)",
    "epoch_mjd": 60600.0,
    "a": 0.6262,
    "e": 0.6268,
    "i": 5.11,
    "om": 245.43,
    "w": 106.69,
    "ma": 332.05,
    "diameter": 0.361,
    "pha": "N",
    "class": "ATE",
    "per": "181"
  },
  "333889 (1998 SV4)": {
    "name": "333889 (1998 SV4)",
    "epoch_mjd": 60600.0,
    "a": 0.8165,
    "e": 0.642,
    "i": 53.3,
    "om": 177.24,
    "w": 359.52,
    "ma": 287.54,
    "diameter": 0.919,
    "pha": "N",
    "class": "ATE",
    "per": "269"
  },
  "337248 (2000 RH60)": {
    "name": "337248 (2000 RH60)",
    "epoch_mjd": 60600.0,
    "a": 0.8259,
    "e": 0.5513,
    "i": 19.65,
    "om": 177.86,
    "w": 354.41,
    "ma": 216.27,
    "diameter": 0.846,
    "pha": "N",
    "class": "ATE",
    "per": "274"
  },
  "341843 (2008 EV5)": {
    "name": "341843 (2008 EV5)",
    "epoch_mjd": 60600.0,
    "a": 0.9602,
    "e": 0.0827,
    "i": 7.45,
    "om": 93.23,
    "w": 235.84,
    "ma": 63.75,
    "diameter": 0.4,
    "pha": "Y",
    "class": "ATE",
    "per": "344"
  },
  "345705 (2006 VB14)": {
    "name": "345705 (2006 VB14)",
    "epoch_mjd": 60600.0,
    "a": 0.767,
    "e": 0.4212,
    "i": 31.03,
    "om": 258.71,
    "w": 346.46,
    "ma": 75.49,
    "diameter": 0.406,
    "pha": "N",
    "class": "ATE",
    "per": "245"
  },
  "345722 (2007 BG29)": {
    "name": "345722 (2007 BG29)",
    "epoch_mjd": 60600.0,
    "a": 0.8327,
    "e": 0.3347,
    "i": 18.51,
    "om": 60.95,
    "w": 245.15,
    "ma": 341.97,
    "diameter": 0.653,
    "pha": "N",
    "class": "ATE",
    "per": "278"
  },
  "363027 (1998 ST27)": {
    "name": "363027 (1998 ST27)",
    "epoch_mjd": 60600.0,
    "a": 0.8198,
    "e": 0.5298,
    "i": 21.06,
    "om": 197.52,
    "w": 322.43,
    "ma": 277.29,
    "diameter": 0.578,
    "pha": "Y",
    "class": "ATE",
    "per": "271"
  },
  "363505 (2003 UC20)": {
    "name": "363505 (2003 UC20)",
    "epoch_mjd": 60600.0,
    "a": 0.7812,
    "e": 0.3369,
    "i": 3.78,
    "om": 187.93,
    "w": 60.16,
    "ma": 266.87,
    "diameter": 1.876,
    "pha": "Y",
    "class": "ATE",
    "per": "252"
  },
  "365424 (2010 KX7)": {
    "name": "365424 (2010 KX7)",
    "epoch_mjd": 60600.0,
    "a": 0.9893,
    "e": 0.1709,
    "i": 21.49,
    "om": 46.46,
    "w": 61.93,
    "ma": 331.91,
    "diameter": 0.212,
    "pha": "Y",
    "class": "ATE",
    "per": "359"
  },
  "365449 (2010 NJ1)": {
    "name": "365449 (2010 NJ1)",
    "epoch_mjd": 60600.0,
    "a": 0.9684,
    "e": 0.5406,
    "i": 11.22,
    "om": 128.23,
    "w": 358.58,
    "ma": 75.23,
    "diameter": 0.215,
    "pha": "N",
    "class": "ATE",
    "per": "348"
  },
  "368184 (2000 RN77)": {
    "name": "368184 (2000 RN77)",
    "epoch_mjd": 60600.0,
    "a": 0.9512,
    "e": 0.3181,
    "i": 16.1,
    "om": 312.69,
    "w": 211.77,
    "ma": 188.89,
    "diameter": 0.381,
    "pha": "N",
    "class": "ATE",
    "per": "339"
  },
  "387733 (2003 GS)": {
    "name": "387733 (2003 GS)",
    "epoch_mjd": 60600.0,
    "a": 0.893,
    "e": 0.2185,
    "i": 12.03,
    "om": 196.2,
    "w": 181.88,
    "ma": 354.33,
    "diameter": 0.344,
    "pha": "N",
    "class": "ATE",
    "per": "308"
  },
  "388189 (2006 DS14)": {
    "name": "388189 (2006 DS14)",
    "epoch_mjd": 60600.0,
    "a": 0.8638,
    "e": 0.3365,
    "i": 26.54,
    "om": 162.24,
    "w": 187.5,
    "ma": 240.74,
    "diameter": 0.315,
    "pha": "N",
    "class": "ATE",
    "per": "293"
  },
  "390725 (2003 HB)": {
    "name": "390725 (2003 HB)",
    "epoch_mjd": 60600.0,
    "a": 0.8497,
    "e": 0.3805,
    "i": 18.11,
    "om": 70.36,
    "w": 306.76,
    "ma": 347.31,
    "diameter": 0.293,
    "pha": "Y",
    "class": "ATE",
    "per": "286"
  },
  "394392 (2007 EP88)": {
    "name": "394392 (2007 EP88)",
    "epoch_mjd": 60600.0,
    "a": 0.8373,
    "e": 0.8859,
    "i": 20.74,
    "om": 328.49,
    "w": 47.12,
    "ma": 101.84,
    "diameter": 0.636,
    "pha": "N",
    "class": "ATE",
    "per": "280"
  },
  "398188 Agni (2010 LE15)": {
    "name": "398188 Agni (2010 LE15)",
    "epoch_mjd": 60600.0,
    "a": 0.8646,
    "e": 0.2733,
    "i": 13.25,
    "om": 134.18,
    "w": 328.62,
    "ma": 122.49,
    "diameter": 0.462,
    "pha": "Y",
    "class": "ATE",
    "per": "294"
  },
  "414286 (2008 OC6)": {
    "name": "414286 (2008 OC6)",
    "epoch_mjd": 60600.0,
    "a": 0.9231,
    "e": 0.1992,
    "i": 21.85,
    "om": 177.57,
    "w": 295.86,
    "ma": 11.73,
    "diameter": 0.369,
    "pha": "Y",
    "class": "ATE",
    "per": "324"
  },
  "418797 (2008 VF)": {
    "name": "418797 (2008 VF)",
    "epoch_mjd": 60600.0,
    "a": 0.9059,
    "e": 0.3258,
    "i": 26.2,
    "om": 234.4,
    "w": 3.28,
    "ma": 353.12,
    "diameter": 0.789,
    "pha": "N",
    "class": "ATE",
    "per": "315"
  },
  "422686 (2000 AC6)": {
    "name": "422686 (2000 AC6)",
    "epoch_mjd": 60600.0,
    "a": 0.8537,
    "e": 0.2864,
    "i": 4.7,
    "om": 101.36,
    "w": 188.07,
    "ma": 335.02,
    "diameter": 0.176,
    "pha": "Y",
    "class": "ATE",
    "per": "288"
  },
  "436030 (2009 JO2)": {
    "name": "436030 (2009 JO2)",
    "epoch_mjd": 60600.0,
    "a": 0.8883,
    "e": 0.4783,
    "i": 19.63,
    "om": 203.42,
    "w": 239.71,
    "ma": 216.35,
    "diameter": 0.295,
    "pha": "N",
    "class": "ATE",
    "per": "306"
  },
  "450237 (2002 XY38)": {
    "name": "450237 (2002 XY38)",
    "epoch_mjd": 60600.0,
    "a": 0.9112,
    "e": 0.2176,
    "i": 2.12,
    "om": 158.7,
    "w": 119.92,
    "ma": 200.77,
    "diameter": 0.096,
    "pha": "N",
    "class": "ATE",
    "per": "318"
  },
  "456537 (2007 BG)": {
    "name": "456537 (2007 BG)",
    "epoch_mjd": 60600.0,
    "a": 0.7868,
    "e": 0.3305,
    "i": 12.75,
    "om": 168.28,
    "w": 133.38,
    "ma": 317.57,
    "diameter": 0.308,
    "pha": "N",
    "class": "ATE",
    "per": "255"
  },
  "462238 (2008 CN1)": {
    "name": "462238 (2008 CN1)",
    "epoch_mjd": 60600.0,
    "a": 0.7707,
    "e": 0.3477,
    "i": 7.22,
    "om": 331.46,
    "w": 7.26,
    "ma": 26.27,
    "diameter": 0.227,
    "pha": "Y",
    "class": "ATE",
    "per": "247"
  },
  "464798 (2004 JX20)": {
    "name": "464798 (2004 JX20)",
    "epoch_mjd": 60600.0,
    "a": 0.9016,
    "e": 0.2657,
    "i": 10.53,
    "om": 101.74,
    "w": 349.12,
    "ma": 65.91,
    "diameter": 1.109,
    "pha": "N",
    "class": "ATE",
    "per": "313"
  },
  "467352 (2003 KZ18)": {
    "name": "467352 (2003 KZ18)",
    "epoch_mjd": 60600.0,
    "a": 0.949,
    "e": 0.3308,
    "i": 23.89,
    "om": 249.95,
    "w": 154.63,
    "ma": 272.76,
    "diameter": 0.47,
    "pha": "N",
    "class": "ATE",
    "per": "338"
  },
  "468468 (2004 KH17)": {
    "name": "468468 (2004 KH17)",
    "epoch_mjd": 60600.0,
    "a": 0.7121,
    "e": 0.4982,
    "i": 22.13,
    "om": 79.12,
    "w": 340.72,
    "ma": 176.08,
    "diameter": 0.197,
    "pha": "Y",
    "class": "ATE",
    "per": "220"
  },
  "468727 (2010 JE87)": {
    "name": "468727 (2010 JE87)",
    "epoch_mjd": 60600.0,
    "a": 0.9042,
    "e": 0.437,
    "i": 16.91,
    "om": 120.47,
    "w": 242.31,
    "ma": 194.33,
    "diameter": 0.308,
    "pha": "Y",
    "class": "ATE",
    "per": "314"
  },
  "469445 (2002 LT24)": {
    "name": "469445 (2002 LT24)",
    "epoch_mjd": 60600.0,
    "a": 0.7201,
    "e": 0.4958,
    "i": 0.77,
    "om": 165.66,
    "w": 283.09,
    "ma": 17.11,
    "diameter": 0.143,
    "pha": "N",
    "class": "ATE",
    "per": "223"
  },
  "488803 (2005 GB120)": {
    "name": "488803 (2005 GB120)",
    "epoch_mjd": 60600.0,
    "a": 0.7911,
    "e": 0.3948,
    "i": 9.15,
    "om": 160.86,
    "w": 243.83,
    "ma": 23.17,
    "diameter": 0.209,
    "pha": "N",
    "class": "ATE",
    "per": "257"
  },
  "490581 (2009 WZ104)": {
    "name": "490581 (2009 WZ104)",
    "epoch_mjd": 60600.0,
    "a": 0.8553,
    "e": 0.1927,
    "i": 9.84,
    "om": 263.25,
    "w": 10.56,
    "ma": 71.51,
    "diameter": 0.237,
    "pha": "Y",
    "class": "ATE",
    "per": "289"
  },
  "523664 (2012 OD1)": {
    "name": "523664 (2012 OD1)",
    "epoch_mjd": 60600.0,
    "a": 0.8288,
    "e": 0.5029,
    "i": 42.26,
    "om": 303.73,
    "w": 224.36,
    "ma": 191.12,
    "diameter": 0.346,
    "pha": "Y",
    "class": "ATE",
    "per": "276"
  },
  "530938 (2011 XE)": {
    "name": "530938 (2011 XE)",
    "epoch_mjd": 60600.0,
    "a": 0.7839,
    "e": 0.4634,
    "i": 20.72,
    "om": 221.25,
    "w": 46.62,
    "ma": 331.73,
    "diameter": 0.413,
    "pha": "N",
    "class": "ATE",
    "per": "254"
  },
  "537829 (2015 XY378)": {
    "name": "537829 (2015 XY378)",
    "epoch_mjd": 60600.0,
    "a": 0.7102,
    "e": 0.4893,
    "i": 13.92,
    "om": 1.21,
    "w": 265.66,
    "ma": 120.68,
    "diameter": 0.312,
    "pha": "N",
    "class": "ATE",
    "per": "219"
  },
  "613726 (2007 EF)": {
    "name": "613726 (2007 EF)",
    "epoch_mjd": 60600.0,
    "a": 0.8203,
    "e": 0.4101,
    "i": 21.73,
    "om": 158.34,
    "w": 226.04,
    "ma": 348.52,
    "diameter": 0.26,
    "pha": "Y",
    "class": "ATE",
    "per": "271"
  },
  "613939 (2008 CH116)": {
    "name": "613939 (2008 CH116)",
    "epoch_mjd": 60600.0,
    "a": 0.6628,
    "e": 0.5875,
    "i": 20.37,
    "om": 85.9,
    "w": 248.18,
    "ma": 196.09,
    "diameter": 0.322,
    "pha": "N",
    "class": "ATE",
    "per": "197"
  },
  "618348 (2016 PN)": {
    "name": "618348 (2016 PN)",
    "epoch_mjd": 60600.0,
    "a": 0.8586,
    "e": 0.3322,
    "i": 21.6,
    "om": 126.04,
    "w": 23.68,
    "ma": 247.3,
    "diameter": 0.16,
    "pha": "N",
    "class": "ATE",
    "per": "291"
  },
  "620091 (2015 FD341)": {
    "name": "620091 (2015 FD341)",
    "epoch_mjd": 60600.0,
    "a": 0.9552,
    "e": 0.6751,
    "i": 20.54,
    "om": 7.52,
    "w": 67.01,
    "ma": 172.2,
    "diameter": 1.248,
    "pha": "N",
    "class": "ATE",
    "per": "341"
  },
  "666241 (2010 BK2)": {
    "name": "666241 (2010 BK2)",
    "epoch_mjd": 60600.0,
    "a": 0.9042,
    "e": 0.4479,
    "i": 6.05,
    "om": 278.01,
    "w": 72.66,
    "ma": 133.58,
    "diameter": 0.118,
    "pha": "N",
    "class": "ATE",
    "per": "314"
  },
  "706765 (2010 TK7)": {
    "name": "706765 (2010 TK7)",
    "epoch_mjd": 60600.0,
    "a": 0.9987,
    "e": 0.1903,
    "i": 20.9,
    "om": 96.42,
    "w": 46.05,
    "ma": 271.82,
    "diameter": 0.379,
    "pha": "N",
    "class": "ATE",
    "per": "365"
  }
};